import { render, staticRenderFns } from "./selectbox.vue?vue&type=template&id=2912913c&scoped=true&"
import script from "./selectbox.vue?vue&type=script&lang=ts&"
export * from "./selectbox.vue?vue&type=script&lang=ts&"
import style0 from "./selectbox.vue?vue&type=style&index=0&id=2912913c&lang=scss&scoped=true&"
import style1 from "./selectbox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2912913c",
  null
  
)

export default component.exports